/* unplugin-vue-components disabled */import { render } from "./WeetPlayerChapter.vue?vue&type=template&id=d61672c2&scoped=true&ts=true"
import script from "./WeetPlayerChapter.vue?vue&type=script&lang=ts"
export * from "./WeetPlayerChapter.vue?vue&type=script&lang=ts"

import "./WeetPlayerChapter.vue?vue&type=style&index=0&id=d61672c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d61672c2"]])

export default __exports__